import "./Phenolic.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import Phenolicservicehero from "./sections/Phenolicservicehero";
import Phenolicengravingtechnicaldetail from "./sections/Phenolicengravingtechnicaldetail";
import Phenolicengravingtechnicaloverview from "./sections/Phenolicengravingtechnicaloverview";
import Materialcomparison from "./sections/Materialcomparison";
import Phenolicengravingspecs from "./sections/Phenolicengravingspecs";
import Mountingmethodstechnical from "./sections/Mountingmethodstechnical";
import Phenolicengravingcapabilities from "./sections/Phenolicengravingcapabilities";
import Engravingorderprocess from "./sections/Engravingorderprocess";
import Phenoliccompliancestandards from "./sections/Phenoliccompliancestandards";
import Phenolicengravingfaq from "./sections/Phenolicengravingfaq";
import Engravingquotecta from "./sections/Engravingquotecta";
export default function PhenolicPage() {
  return <div>
      <Header />
      <Phenolicengravingtechnicaldetail />
      <Phenolicservicehero />
      <Phenolicengravingtechnicaloverview />
      <Materialcomparison />
      <Phenolicengravingspecs />
      <Mountingmethodstechnical />
      <Phenolicengravingcapabilities />
      <Engravingorderprocess />
      <Phenoliccompliancestandards />
      <Phenolicengravingfaq />
      <Engravingquotecta />
      <Footer />
    </div>;
}